var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHangerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 41,
    viewBox: "0 0 48 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.01 7C29.01 5.67392 28.4832 4.40215 27.5455 3.46447C26.6079 2.52678 25.3361 2 24.01 2C22.6839 2 21.4121 2.52678 20.4745 3.46447C19.5368 4.40215 19.01 5.67392 19.01 7C19.0175 11.1675 20.685 14.5 24.02 17H24L43.9275 28.07C44.7074 28.5031 45.3571 29.1369 45.8095 29.9058C46.2618 30.6746 46.5002 31.5505 46.5 32.4425V34.5C46.5 35.8261 45.9732 37.0979 45.0355 38.0355C44.0979 38.9732 42.8261 39.5 41.5 39.5H6.5C5.17392 39.5 3.90215 38.9732 2.96447 38.0355C2.02678 37.0979 1.5 35.8261 1.5 34.5V32.4425C1.49977 31.5505 1.73818 30.6746 2.19052 29.9058C2.64286 29.1369 3.29265 28.5031 4.0725 28.07L24 17",
    stroke: "#E1EEFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHangerIcon);
export default __webpack_public_path__ + "static/media/hanger_icon.be6bde622ac76cbae78359892e147c99.svg";
export { ForwardRef as ReactComponent };